import { Link } from "react-router-dom";

export function PageError404(){

    const handleGoBack = () => {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            // Si pas d'historique, rediriger vers une page par défaut
            window.location.href = "/";
        }
    };

    return(
        <>
            {/*Page d'erreur 404 pour les routes non définies*/}
            <div className="fix-wrapper">
                <div className="container">
                    <div className="row justify-content-center align-items-center min-vh-100">
                        <div className="col-md-8 col-lg-6">
                            <div className="form-input-content text-center error-page">
                                
                                {/* Animation moderne */}
                                <div className="mb-4">
                                    <div className="error-404-animation">
                                        <div className="error-circle-1"></div>
                                        <div className="error-circle-2"></div>
                                        <h1 className="error-text font-weight-bold text-gradient">404</h1>
                                    </div>
                                </div>
                                
                                {/* Message d'erreur */}
                                <div className="error-content mb-5">
                                    <div className="error-icon mb-3">
                                        <i className="fa fa-exclamation-triangle text-warning fa-3x"></i>
                                    </div>
                                    <h3 className="text-dark mb-3">Page introuvable</h3>
                                    <p className="text-muted mb-4">
                                        La page que vous recherchez semble avoir été déplacée, supprimée 
                                        ou n'existe pas. Vérifiez l'URL et réessayez.
                                    </p>
                                </div>

                                {/* Boutons d'action */}
                                <div className="error-actions d-flex flex-column flex-sm-row justify-content-center gap-3">
                                    <button 
                                        onClick={handleGoBack}
                                        className="btn btn-primary btn-lg px-4 py-2 back-button"
                                    >
                                        <i className="fa fa-arrow-left me-2"></i>
                                        Retour à la page précédente
                                    </button>
                                    
                                    <Link 
                                        to="/" 
                                        className="btn btn-outline-primary btn-lg px-4 py-2 home-button"
                                    >
                                        <i className="fa fa-home me-2"></i>
                                        Page d'accueil
                                    </Link>
                                </div>

                                {/* Message supplémentaire */}
                                <div className="mt-5">
                                    <p className="text-small text-muted">
                                        Si le problème persiste, contactez notre support technique.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Styles CSS intégrés pour l'animation et le design moderne */}
            <style jsx>{`
                .min-vh-100 {
                    min-height: 100vh;
                }
                
                .text-gradient {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    font-size: 8rem;
                    font-weight: 900;
                }
                
                .error-404-animation {
                    position: relative;
                    display: inline-block;
                }
                
                .error-circle-1, .error-circle-2 {
                    position: absolute;
                    border-radius: 50%;
                    border: 3px solid rgba(102, 126, 234, 0.1);
                    animation: pulse 2s infinite;
                }
                
                .error-circle-1 {
                    width: 200px;
                    height: 200px;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
                
                .error-circle-2 {
                    width: 240px;
                    height: 240px;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    animation-delay: 0.5s;
                }
                
                @keyframes pulse {
                    0% {
                        transform: translate(-50%, -50%) scale(0.8);
                        opacity: 1;
                    }
                    70% {
                        transform: translate(-50%, -50%) scale(1.2);
                        opacity: 0;
                    }
                    100% {
                        transform: translate(-50%, -50%) scale(0.8);
                        opacity: 0;
                    }
                }
                
                .back-button {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    border: none;
                    border-radius: 50px;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
                }
                
                .back-button:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
                }
                
                .home-button {
                    border-radius: 50px;
                    border: 2px solid #667eea;
                    color: #667eea;
                    transition: all 0.3s ease;
                }
                
                .home-button:hover {
                    background: #667eea;
                    color: white;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
                }
                
                .error-content {
                    background: rgba(255, 255, 255, 0.8);
                    padding: 2rem;
                    border-radius: 20px;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
                    backdrop-filter: blur(10px);
                }
                
                .text-small {
                    font-size: 0.875rem;
                }
                
                /* Responsive */
                @media (max-width: 768px) {
                    .text-gradient {
                        font-size: 5rem;
                    }
                    
                    .error-circle-1 {
                        width: 150px;
                        height: 150px;
                    }
                    
                    .error-circle-2 {
                        width: 180px;
                        height: 180px;
                    }
                    
                    .error-actions {
                        flex-direction: column;
                    }
                }
            `}</style>
        </>
    );
};

export default PageError404;